import github from "../svgs/github.svg";
import insta from "../svgs/insta.svg";
import linkedin from "../svgs/linkedin.svg";
import fiverr from "../svgs/fiverr.svg";

const socials = [
  { name: "Github", url: "https://github.com/Vickeysvibe", icon: github },
  {
    name: "Instagram",
    url: "https://www.instagram.com/vickeys_vibe/",
    icon: insta,
  },
  {
    name: "Linkedin",
    url: "https://www.linkedin.com/in/vigneshwaran-l-0b9004257/",
    icon: linkedin,
  },
  {
    name: "Fiverr",
    url: "https://www.fiverr.com/vickeyss?up_rollout=true",
    icon: fiverr,
  },
];

export default socials;
